var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxClipboardOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7003 2.80005H8.37723C7.76547 2.80005 7.26953 3.29598 7.26953 3.90773V4.46157C7.26953 5.07332 7.76547 5.56926 8.37723 5.56926H11.7003C12.3121 5.56926 12.808 5.07332 12.808 4.46157V3.90773C12.808 3.29598 12.3121 2.80005 11.7003 2.80005Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0862 3.90796H14.7477C15.0415 3.90796 15.3233 4.02466 15.531 4.23239C15.7387 4.44012 15.8554 4.72186 15.8554 5.01564V16.0925C15.8554 16.3862 15.7387 16.668 15.531 16.8757C15.3233 17.0834 15.0415 17.2002 14.7477 17.2002H5.33231C5.03852 17.2002 4.75678 17.0834 4.54904 16.8757C4.34132 16.668 4.22461 16.3862 4.22461 16.0925V5.01564C4.22461 4.72186 4.34132 4.44012 4.54904 4.23239C4.75678 4.02466 5.03852 3.90796 5.33231 3.90796H6.99385",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxClipboardOutline);
export default __webpack_public_path__ + "static/media/icon_20px_clipboard_outline.bbfcd4c947f2176de633cef0c74774a1.svg";
export { ForwardRef as ReactComponent };